
import { Row, Col, Image } from 'antd';
import { PATH_IMAGE } from '../../../helper/path';



const ViewProduct = ({product}) => {
  const {image, price} = product



  return (
    <>
      <Row style={{minHeight: "50vh"}} className="d-flex justify-content-center align-align-items-center">
        <Col className="py-3 bg-primary-subtle border-1 rounded-3 d-flex justify-content-around flex-lg-row flex-column align-items-center" span={24}>
        <Image
          src={PATH_IMAGE+image?.path}
          className="mb-3"
          style={{maxWidth: "400px", maxHeight: "350px"}}
          />
          <table>
            <tr>
              <th className="d-inline fw-bold fs-5 me-3">Name:</th>
              <td>{product?.name}</td>
            </tr>
            <tr>
              <th className="d-inline fw-bold fs-5 me-3">Category:</th>
              <td>{product?.category?.name}</td>
            </tr>
            <tr>
              <th className="d-inline fw-bold fs-5 me-3">Description:</th>
              <td>{product?.description}</td>
            </tr>
            <tr>
              <th className="d-inline fw-bold fs-5 me-3">Price:</th>
              <td>{price?.amount} <span>{price?.currency?.name}</span></td>
            </tr>
            <tr>
              <th className="d-inline fw-bold fs-5 me-3">Residual:</th>
              <td>{product?.residual}</td>
            </tr>
          </table>
        </Col>
      </Row>
    </>
  )
}

export default ViewProduct